export { default } from './Ranking.component';
